module.exports = __webpack_public_path__ + "img/kc01.fca98abc.png";